import Switch from './src/component';

Switch.install = function(Vue) {
  Vue.component(Switch.name, Switch);
};

export default Switch;




// WEBPACK FOOTER //
// ./src/components/switch/index.js